<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">保障案例<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>宠物类型</label>
              <el-select v-model="petType" placeholder="Select" class="select-item">
                <el-option v-for="item in petTypeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>展示状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="创建时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>
            <div class="content-input-item">
              <label>发布状态</label>
              <el-select v-model="anonymous" placeholder="Select" class="select-item">
                <el-option v-for="item in anonymousArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="发布时间" @date="getPushTime($event)" @check="getPushCheck($event)" :isChecked="isPushChecked"/>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editCaseDialog(-1)" size="default">新建案例</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
              @sort-change="sortChange"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" sortable='custom'/>
            <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" width="100">
              <template #default="scope">
                <div v-if="scope.row.smallHeadImg" class="cursor">
                  <el-image class="item-img" fit="cover" :src="scope.row.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="发布状态" v-if="checkColList.indexOf('发布状态') > -1">
              <template #default="scope">
                <p>{{scope.row.anonymous == 0?'公开':scope.row.anonymous == 1?'匿名':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column property="title" label="宠物信息" v-if="checkColList.indexOf('宠物信息') > -1">
              <template #default="scope">
                <p>名称: {{scope.row.petName}}</p>
                <p>物种: {{scope.row.petType == 1?'猫':'狗'}}</p>
                <p>品种: {{scope.row.petBreedName}}<span v-if="scope.row.petType == 1">{{'/' + scope.row.petBreedColorName}}</span></p>
                <p>年龄: <span v-if="scope.row.age || scope.row.month">{{scope.row.age}}岁{{scope.row.month}}个月</span></p>
              </template>
            </el-table-column>
            <el-table-column property="content" label="情况描述" v-if="checkColList.indexOf('情况描述') > -1"/>
            <el-table-column property="payExpense" label="总共花费（元）" v-if="checkColList.indexOf('总共花费（元）') > -1">
              <template #default="scope">
                <p v-if="scope.row.payExpense">{{scope.row.payExpense}}</p>
              </template>
            </el-table-column>
            <el-table-column property="claimExpense" label="获得报销（元）" v-if="checkColList.indexOf('获得报销（元）') > -1">
              <template #default="scope">
                <p v-if="scope.row.claimExpense">{{scope.row.claimExpense}}</p>
              </template>
            </el-table-column>
            <el-table-column property="pushTime" label="发布时间" v-if="checkColList.indexOf('发布时间') > -1" sortable='custom'/>
            <el-table-column property="" label="图片" v-if="checkColList.indexOf('图片') > -1" width="260">
              <template #default="scope">
                <el-space wrap>
                  <div class="img-box" v-for="(item, index) in scope.row.imgList" :key="item.id">
                    <el-image @click="showImg(scope.row.imgList, index) " style="width: 64px; height: 64px;cursor: pointer" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                    <div class="delIcon" @click="delImg(index, scope.row.imgList)"><ElIcons name="CloseBold" color="#ffffff"/></div>
                  </div>
                  <div v-if="scope.row.imgList.length < 9" class="add-btn" @click="addImg(scope.row)">+</div>
                </el-space>
              </template>
            </el-table-column>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待展示':scope.row.state == 1?'已上架':scope.row.state == 2?'已下架':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="140">
              <template #default="scope">
                <el-space direction="vertical">
                  <el-button @click="editCaseDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 1" @click="updateState(scope.row, 2)" size="small" type="warning" v-loading="scope.row.updateLoading">下架</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">上架</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getMedicalCasePageList, udpateMedicalCaseState, delMedicalCaseImg} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import ImgViewer from "@/assets/js/imageViewer";
import caseDialog from "@/views/medical/components/caseDialog"
import DatePickerRange from "@/components/DatePickerRange";
import imgUpload from "./components/imgUpload";

export default {
  name: "MedicalSecurityCase",
  components: { BtnGroup, DatePickerRange, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: -1},
      ],
      shopIdArr:[],
      shopId: -1,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待展示', value: 0},
        {label: '已上架', value: 1},
        {label: '已下架', value: 2}
      ],
      state: -1,

      anonymous: -1,
      anonymousArray: [
        {label: '不限', value: -1},
        {label: '公开', value: 0},
        {label: '匿名', value: 1}
      ],

      petTypeArray: [
        {label: '不限', value: -1},
        {label: '猫', value: 1},
        {label: '狗', value: 2}
      ],
      petType: -1,

      //刷新组
      colList: ['创建时间', '头像', '发布状态', '宠物信息', '情况描述', '总共花费（元）', '获得报销（元）', '发布时间', '图片', '状态', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '门店名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //时间
      pushStartTime: '',
      pushEndTime: '',
      isPushChecked: true,

      sort: 2,

    }
  },
  methods: {

    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.isPushChecked = true;
      this.petType = -1;
      this.state = -1;
      this.anonymous = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getPushTime(val) {
      this.pushStartTime = val[0];
      this.pushEndTime = val[1];
      // console.log(val)
    },
    getPushCheck(val) {
      this.isPushChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'createTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'pushTime') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      }
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['type'] = 2
      param['petType'] = this.petType;
      param['anonymous'] = this.anonymous;
      param['state'] = this.state;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['pushStartTime'] = this.pushStartTime;
      param['pushEndTime'] = this.pushEndTime;
      param['sort'] = this.sort;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMedicalCasePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editCaseDialog(idx, row) {
      let _title = '';
      let caseForm = {}
      if (idx > -1) {
        _title = '编辑案例'
        caseForm = Object.assign({}, row);
        // console.log(caseForm)
      }else {
        _title = '添加案例'
        // console.log(caseForm)
      }
      Dialog.open({
        title: _title,
        component: caseDialog,
        data: {
          caseForm: caseForm,
          ids: idx,
          type: 2,
          width: '600px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },



    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(udpateMedicalCaseState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    addImg(row) {
      Dialog.open({
        title: '上传图片',
        component: imgUpload,
        data: {
          imgList: row.imgList,
          id: row.id,
          width: '900px',
          type: 2,
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    delImg(idx, list) {
      postFormData(delMedicalCaseImg, {id: list[idx].id, type: 2}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          list.splice(idx, 1)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    showImg(list, idx) {
      let imgList = []
      for(let i=0; i<list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList: imgList,
        imgIndex: idx
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 64px;
  height: 64px;
}
.add-btn {
  width: 64px;
  height: 64px;
  border: 1px solid #ededed;
  text-align: center;
  line-height: 64px;
  cursor: pointer;
}
.img-box {
  width: 64px;
  height: 64px;
  position: relative;
}
.delIcon {
  background-color: rgba(0,0,0,0.5);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
